<template>
  <div class="navbar-container d-flex content align-items-center">

    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{getName}}
            </p>
          </div>
          <UserInfoLogo />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import store from "@/store";
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import UserInfoLogo from "@/components/UserInfoLogo";

import LoginService from "@/services/LoginService";

export default {
  components: {
    DarkToggler,
    UserInfoLogo
  },
  mounted() {
    LoginService.getUserInfo().then(resp => {
      store.commit('user/setName', resp.data.nome_completo)
      store.commit('user/setSex', resp.data.sexo)
    }).catch(err => {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Oops!',
          icon: 'BellIcon',
          text: 'Ocorreu um erro ao buscar os dados do usuário.',
          variant: 'danger',
        },
      },
      {
        position: 'top-center'
      })
    });
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    getName(){
      return store.getters["user/getName"];
    }
  }
}
</script>
